import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSingleSurveyWithR } from "../../../services/survey.service";
import {
  List,
  ListItem,
  ListItemText,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";

const SurveyRespondents = () => {
  const { surveyId } = useParams();
  const navigate = useNavigate();
  const [respondents, setRespondents] = useState([]);
  const [survey, setSurvey] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSurveyData = async () => {
      setLoading(true);
      try {
        const surveyData = await getSingleSurveyWithR(surveyId);
        setSurvey(surveyData);
        const respondentsData = surveyData.native_responses.reduce(
          (acc, response) => {
            if (response.externalUserId) {
              if (!acc[response.externalUserId]) {
                acc[response.externalUserId] = [];
              }
              acc[response.externalUserId].push(response);
            }
            return acc;
          },
          {}
        );
        setRespondents(Object.entries(respondentsData));
      } catch (error) {
        console.error("Error fetching survey respondents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSurveyData();
  }, [surveyId]);

  const handleOpenProfile = (respondentId) => {
    const userResponses = respondents.find(([id, _]) => id === respondentId)[1];

    const sortedResponses = [...userResponses].sort((a, b) => a.nativeQuestionId - b.nativeQuestionId);

    const formattedResponses = {};
    sortedResponses.forEach((response, index) => {
      formattedResponses[`Pregunta${index + 1}`] = response.content;
    });

    navigate(`/surveys/values-profile/${surveyId}`, {
      state: { survey, responses: formattedResponses },
    });
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <h1>Encuestados</h1>
      <List>
        {respondents.map(([respondentId, responses], index) => (
          <ListItem key={respondentId}>
            <ListItemText primary={respondentId.split('_')[0]} />
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleOpenProfile(respondentId)}
            >
              Ver Perfil
            </Button>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default SurveyRespondents;